import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  Duration5ynfiptaqcrg as Duration,
  Duration__toIsoString_impl_9h6wsm1isvj2n1k1yz8 as Duration__toIsoString_impl_9h6wsm,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ContributionId1kgq0od2ulxrt as ContributionId } from '../../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/ContributionId.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  NotBlankString2t6vf2scdbmna as NotBlankString,
  toNotBlankString1ovj48s0kinvm as toNotBlankString,
  NotBlankString__toString_impl_5tex9r3bdt5aydt9d7j as NotBlankString__toString_impl_5tex9r,
} from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import { PartyId30onj62xl01at as PartyId } from '../../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/party/PartyId.mjs';
import { PlayerId3vdbn0bzxjwb4 as PlayerId } from '../../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/player/PlayerId.mjs';
import { PinId3lhhfdu3qni8f as PinId } from '../../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/pin/Pin.mjs';
import { SecretId2b1ivn24svpd4 as SecretId } from '../../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/party/SecretId.mjs';
import { UserId1bjlkq3ivhppd as UserId } from '../../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/user/UserId.mjs';
import { PairingSetId2cohvchymqgsy as PairingSetId } from '../../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/pairassignmentdocument/PairingSetId.mjs';
import {
  Result3t1vadv16kmzk as Result,
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpiriv2yxkms7bg2hpm as _Result___get_isFailure__impl__jpiriv,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { NullPointerException3mu0rhxjjitqq as NullPointerException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_contributionAdapter() {
  _init_properties_Adapter_kt__th4orn();
  return contributionAdapter;
}
var contributionAdapter;
function get_partyIdAdapter() {
  _init_properties_Adapter_kt__th4orn();
  return partyIdAdapter;
}
var partyIdAdapter;
function get_playerIdAdapter() {
  _init_properties_Adapter_kt__th4orn();
  return playerIdAdapter;
}
var playerIdAdapter;
function get_pinIdAdapter() {
  _init_properties_Adapter_kt__th4orn();
  return pinIdAdapter;
}
var pinIdAdapter;
function get_secretIdAdapter() {
  _init_properties_Adapter_kt__th4orn();
  return secretIdAdapter;
}
var secretIdAdapter;
function get_userIdAdapter() {
  _init_properties_Adapter_kt__th4orn();
  return userIdAdapter;
}
var userIdAdapter;
function get_pairingSetIdAdapter() {
  _init_properties_Adapter_kt__th4orn();
  return pairingSetIdAdapter;
}
var pairingSetIdAdapter;
function get_notBlankStringAdapter() {
  _init_properties_Adapter_kt__th4orn();
  return notBlankStringAdapter;
}
var notBlankStringAdapter;
function serializationAdapter(init, toValue) {
  _init_properties_Adapter_kt__th4orn();
  return new (serializationAdapter$1())(init, toValue);
}
var KotlinDurationAdapterClass;
function KotlinDurationAdapter() {
  if (KotlinDurationAdapterClass === VOID) {
    class $ {
      fromJson_o1venq_k$(reader, customScalarAdapters) {
        return Companion_getInstance().parse_8aqxct_k$(ensureNotNull(reader.nextString_kwkc9o_k$()));
      }
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        return new (Duration())(this.fromJson_o1venq_k$(reader, customScalarAdapters));
      }
      toJson_jxaj8v_k$(writer, customScalarAdapters, value) {
        writer.value_hphtnt_k$(Duration__toIsoString_impl_9h6wsm(value));
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_jxaj8v_k$(writer, customScalarAdapters, value instanceof Duration() ? value.rawValue_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'KotlinDurationAdapter', VOID, VOID, [Adapter()]);
    KotlinDurationAdapterClass = $;
  }
  return KotlinDurationAdapterClass;
}
var KotlinDurationAdapter_instance;
function KotlinDurationAdapter_getInstance() {
  return KotlinDurationAdapter_instance;
}
function ContributionId$_init_$ref_7ybeii() {
  return constructCallableReference((p0) => new (ContributionId())(p0.value_1), 1, 0, 226, '<init>');
}
function ContributionId$_get_value_$ref_no1s8m() {
  return constructCallableReference((p0) => new (NotBlankString())(p0.value_1), 1, 0, 227);
}
function PartyId$_init_$ref_45kbqc() {
  return constructCallableReference((p0) => new (PartyId())(p0.value_1), 1, 0, 228, '<init>');
}
function PartyId$_get_value_$ref_r1wifg() {
  return constructCallableReference((p0) => new (NotBlankString())(p0.value_1), 1, 0, 229);
}
function PlayerId$_init_$ref_vkax9z() {
  return constructCallableReference((p0) => new (PlayerId())(p0.value_1), 1, 0, 230, '<init>');
}
function PlayerId$_get_value_$ref_s5dvif() {
  return constructCallableReference((p0) => new (NotBlankString())(p0.value_1), 1, 0, 231);
}
function PinId$_init_$ref_wjrvu3() {
  return constructCallableReference((p0) => new (PinId())(p0.value_1), 1, 0, 232, '<init>');
}
function PinId$_get_value_$ref_gzwpmt() {
  return constructCallableReference((p0) => new (NotBlankString())(p0.value_1), 1, 0, 233);
}
function SecretId$_init_$ref_cy9qw6() {
  return constructCallableReference((p0) => new (SecretId())(p0.value_1), 1, 0, 234, '<init>');
}
function SecretId$_get_value_$ref_pzuxii() {
  return constructCallableReference((p0) => new (NotBlankString())(p0.value_1), 1, 0, 235);
}
function UserId$_init_$ref_kjvkgv() {
  return constructCallableReference((p0) => new (UserId())(p0.value_1), 1, 0, 236, '<init>');
}
function UserId$_get_value_$ref_i9dk27() {
  return constructCallableReference((p0) => new (NotBlankString())(p0.value_1), 1, 0, 237);
}
function PairingSetId$_init_$ref_cqwo34() {
  return constructCallableReference((p0) => new (PairingSetId())(p0.value_1), 1, 0, 238, '<init>');
}
function PairingSetId$_get_value_$ref_545sf4() {
  return constructCallableReference((p0) => new (NotBlankString())(p0.value_1), 1, 0, 239);
}
function notBlankStringAdapter$lambda(it) {
  _init_properties_Adapter_kt__th4orn();
  return it;
}
function notBlankStringAdapter$lambda_0(it) {
  _init_properties_Adapter_kt__th4orn();
  return it;
}
var serializationAdapter$1Class;
function serializationAdapter$1() {
  if (serializationAdapter$1Class === VOID) {
    class $ {
      constructor($init, $toValue) {
        this.$init_1 = $init;
        this.$toValue_1 = $toValue;
      }
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        var tmp0_safe_receiver = reader.nextString_kwkc9o_k$();
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : new (Result())(toNotBlankString(tmp0_safe_receiver));
        var tmp;
        if (tmp1_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.Result.getOrNull' call
          var this_0 = tmp1_safe_receiver.value_1;
          var tmp_0 = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
          tmp = tmp_0 == null ? null : tmp_0.value_1;
        }
        var tmp2_safe_receiver = tmp;
        var tmp_1;
        var tmp_2 = tmp2_safe_receiver;
        if ((tmp_2 == null ? null : new (NotBlankString())(tmp_2)) == null) {
          tmp_1 = null;
        } else {
          var tmp_3 = tmp2_safe_receiver;
          var tmp0 = tmp_3 == null ? null : new (NotBlankString())(tmp_3);
          // Inline function 'kotlin.let' call
          tmp_1 = this.$init_1(tmp0);
        }
        var tmp3_elvis_lhs = tmp_1;
        var tmp_4;
        if (tmp3_elvis_lhs == null) {
          throw NullPointerException().new_kotlin_NullPointerException_ehn4fl_k$('Json value was null.');
        } else {
          tmp_4 = tmp3_elvis_lhs;
        }
        return tmp_4;
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        // Inline function 'kotlin.let' call
        var it = this.$toValue_1(value).value_1;
        writer.value_hphtnt_k$(NotBlankString__toString_impl_5tex9r(it));
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    serializationAdapter$1Class = $;
  }
  return serializationAdapter$1Class;
}
var properties_initialized_Adapter_kt_vl0uu7;
function _init_properties_Adapter_kt__th4orn() {
  if (!properties_initialized_Adapter_kt_vl0uu7) {
    properties_initialized_Adapter_kt_vl0uu7 = true;
    var tmp = ContributionId$_init_$ref_7ybeii();
    var tmp_0 = KProperty1();
    contributionAdapter = serializationAdapter(tmp, getPropertyCallableRef('value', 1, tmp_0, ContributionId$_get_value_$ref_no1s8m(), null));
    var tmp_1 = PartyId$_init_$ref_45kbqc();
    var tmp_2 = KProperty1();
    partyIdAdapter = serializationAdapter(tmp_1, getPropertyCallableRef('value', 1, tmp_2, PartyId$_get_value_$ref_r1wifg(), null));
    var tmp_3 = PlayerId$_init_$ref_vkax9z();
    var tmp_4 = KProperty1();
    playerIdAdapter = serializationAdapter(tmp_3, getPropertyCallableRef('value', 1, tmp_4, PlayerId$_get_value_$ref_s5dvif(), null));
    var tmp_5 = PinId$_init_$ref_wjrvu3();
    var tmp_6 = KProperty1();
    pinIdAdapter = serializationAdapter(tmp_5, getPropertyCallableRef('value', 1, tmp_6, PinId$_get_value_$ref_gzwpmt(), null));
    var tmp_7 = SecretId$_init_$ref_cy9qw6();
    var tmp_8 = KProperty1();
    secretIdAdapter = serializationAdapter(tmp_7, getPropertyCallableRef('value', 1, tmp_8, SecretId$_get_value_$ref_pzuxii(), null));
    var tmp_9 = UserId$_init_$ref_kjvkgv();
    var tmp_10 = KProperty1();
    userIdAdapter = serializationAdapter(tmp_9, getPropertyCallableRef('value', 1, tmp_10, UserId$_get_value_$ref_i9dk27(), null));
    var tmp_11 = PairingSetId$_init_$ref_cqwo34();
    var tmp_12 = KProperty1();
    pairingSetIdAdapter = serializationAdapter(tmp_11, getPropertyCallableRef('value', 1, tmp_12, PairingSetId$_get_value_$ref_545sf4(), null));
    var tmp_13 = notBlankStringAdapter$lambda;
    notBlankStringAdapter = serializationAdapter(tmp_13, notBlankStringAdapter$lambda_0);
  }
}
//region block: init
KotlinDurationAdapter_instance = new (KotlinDurationAdapter())();
//endregion
//region block: exports
export {
  get_contributionAdapter as get_contributionAdapter2matul6niev52,
  get_notBlankStringAdapter as get_notBlankStringAdapter7hd2uzboxata,
  get_pairingSetIdAdapter as get_pairingSetIdAdapter204jlhkjchobz,
  get_partyIdAdapter as get_partyIdAdapter2v7zx778kk10s,
  get_pinIdAdapter as get_pinIdAdapter27yg3a7qzsov7,
  get_playerIdAdapter as get_playerIdAdapter2h87xjwribaa,
  get_secretIdAdapter as get_secretIdAdapter1o4zeaz9dqdiz,
  get_userIdAdapter as get_userIdAdapter28jeupgs6n1va,
  KotlinDurationAdapter_instance as KotlinDurationAdapter_instance35qxcf0dm2v0b,
};
//endregion

//# sourceMappingURL=Adapter.mjs.map
